import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=354eabf4&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354eabf4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354eabf4')) {
      api.createRecord('354eabf4', component.options)
    } else {
      api.reload('354eabf4', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=354eabf4&scoped=true&", function () {
      api.rerender('354eabf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/auth/SignUp.vue"
export default component.exports